module.exports = __webpack_public_path__ + "img/logo.88617564.svg";